<div style="direction: rtl;"
  class="z-50 md:h-[80px] h-[140px] gap-2 fixed w-full p-2 grad-main-color justify-between flex md:flex-row flex-col items-center"
>
<div class="flex flex-row items-center gap-4">
  <img src="./assets/logo.svg" />
</div>
  <!-- <div
    class="p-1 max-w-[400px] w-full flex flex-row     "
  >
         <div id="searchWidget" class="w-full"></div>
  </div> -->

  <div class="p-1 max-w-[400px] w-full flex flex-row ">
    <div id="searchWidget" ></div>
  </div>
</div>
